// extracted by mini-css-extract-plugin
export var actionButton = "_qz-0";
export var actionMenuContainer = "_qz-i";
export var bubble = "_qz-2";
export var bubbleActionMenu = "_qz-j";
export var bubbleContext = "_qz-6";
export var bubbleItems = "_qz-7";
export var customer = "_qz-3";
export var divider = "_qz-8";
export var fileList = "_qz-9";
export var hiddenComment = "_qz-o";
export var infoAbove = "_qz-a";
export var internal = "_qz-4";
export var lightActionButton = "_qz-1";
export var link = "_qz-b";
export var merchant = "_qz-5";
export var message = "_qz-c";
export var profilePicture = "_qz-e";
export var quillToolbarContainer = "_qz-f";
export var senderDate = "_qz-g";
export var senderDateCustomer = "_qz-h";
export var senderName = "_qz-d";
export var time = "_qz-k";
export var uploadedImage = "_qz-l";
export var username = "_qz-m";
export var xsmall = "_qz-n";